import DeadlineModal from './DeadlineModal';

export default DeadlineModal;
